import { render } from "./UploadVoucher.vue?vue&type=template&id=0d0cd8aa&scoped=true"
import script from "./UploadVoucher.vue?vue&type=script&lang=js"
export * from "./UploadVoucher.vue?vue&type=script&lang=js"

import "./UploadVoucher.vue?vue&type=style&index=0&id=0d0cd8aa&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0cd8aa"]])

export default __exports__